import { connect } from "react-redux";
import { IStoreState } from "../../../../../../reducers/types";
import {
  getLocation,
  getFromDate,
  getUntilDate,
} from "../../../../reducer/selectors";
import { withRouter } from "react-router";
import { ActionButtonWithRoute } from "halifax";

const mapStateToProps = (
  state: IStoreState,
  ownProps: { from?: Date; until?: Date; enabled?: boolean }
) => {
  const location = getLocation(state);
  const fromDate = getFromDate(state) || ownProps.from;
  const untilDate = getUntilDate(state) || ownProps.until;

  const hasSetLocation = location !== null;
  const areJuncturesSet = !!fromDate && !!untilDate;

  return {
    disabled: ownProps.enabled
      ? !ownProps.enabled
      : !(hasSetLocation && areJuncturesSet),
  };
};

const mapDispatchToProps = {};

export const ConnectedHotelSearchButton = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ActionButtonWithRoute));
